module.exports = __webpack_public_path__ + "img/chris (8).7fe87ff8.jpg";